import { instance } from '@/libs/api/instance'

export const getDetails = (id) => {
  return instance.get(`/v2/card/${id}`)
}

/**
 * Fetch specific card credential fields (cvv, pan, pin, password, phone).
 * @param {string} id - Card UUID
 * @param {Array<'cvv'|'pan'|'pin'|'password'|'phone'>} fields
 */
export const getSpecificDetail = (id, fields) => {
  return instance.post(`/v2/card/${id}/credentials`, { fields })
}
